import {
  createSelector,
  createStructuredSelector,
  defaultMemoize,
} from 'reselect';
import { omit, flow, get, constant } from 'lodash/fp';
import { getBreadcrumbsMetaFromCms } from 'helpers/cms';
import { getSeoSearchUrl } from 'helpers/namedUrls';
import {
  formFromQuery,
  formFromMeta,
  parseAdsSearch,
} from 'components/searchAds';
import { selectCarMakeValues } from 'store/ducks/manufacturers';

import { getCmsResult } from '../../selectors';
import { STORE_KEY, CMS_KEY } from '../../duck';

const getProps = (state, props) => props;

const getQueryFromLocation = createSelector(
  flow(getProps, get(['location', 'search'])),
  parseAdsSearch,
);

const specialMetaFields = ['fields', 'from', 'size', 'sort']; // these fields may conflict with our UI

const getMetaCms = createSelector(
  getCmsResult,
  flow(get(['link-meta']), omit(specialMetaFields)),
);

const getInitialForm = createSelector(
  getMetaCms,
  getQueryFromLocation,
  selectCarMakeValues,
  (cmsMeta, locationQuery, carMakeValues) => {
    const queryForm = formFromQuery(carMakeValues)(locationQuery);
    const cmsForm = flow(
      formFromMeta(queryForm),
      omit(['page', 'pageSize', 'sellerType', 'sort']),
    )(cmsMeta);

    return { ...queryForm, ...cmsForm };
  },
);

const getBreadcrumbs = defaultMemoize(
  getBreadcrumbsMetaFromCms([STORE_KEY, CMS_KEY], ({ link, ...rest }) => ({
    href: getSeoSearchUrl(link),
    ...rest,
  })),
);

const getBreadcrumbsHtml = createSelector(getCmsResult, get(['breadcrumbs']));

export default createStructuredSelector({
  breadcrumbs: getBreadcrumbs,
  breadcrumbsHtml: getBreadcrumbsHtml,
  cms: getCmsResult,
  initialForm: getInitialForm,
  userSearchType: constant('seo'),
  storageKey: constant('seoSearch'),
  withInitialAdResultsAmount: constant(false),
  withPromoBanner: constant(true),
  withWelcomeBanner: constant(false),
});
